import { FieldList } from '../FieldList/FieldList';
import type { LabelValueField } from '../LabelValueFields/LabelValueFields';

interface Props {
  licences?: Array<{
    name: string;
    description?: string;
    issuingOrganisation?: string;
    isVerified?: boolean;
    labelValueFields?: LabelValueField[];
  }>;
}

export const Licences = ({ licences }: Props) => (
  <FieldList
    icon="document"
    iconTone="positive"
    descriptionSize="smallMobile"
    fields={
      licences
        ? licences.map(
            ({
              name,
              description,
              issuingOrganisation,
              isVerified,
              labelValueFields,
            }) => ({
              heading: name,
              description,
              subHeading: issuingOrganisation,
              isVerified,
              labelValueFields,
            }),
          )
        : []
    }
  />
);
